// MT — scripts compartidos del tema (vanilla JS, sin librerías externas)

function mtInitReveals() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach((el) => observer.observe(el));
}

function mtInitProductoGaleria() {
  document.querySelectorAll('[data-mt-galeria]').forEach((galeria) => {
    const principal = galeria.querySelector('[data-mt-galeria-principal]');
    const miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;
    miniaturas.forEach((mini) => {
      mini.addEventListener('click', () => {
        const src = mini.getAttribute('data-full-src');
        if (!src) return;
        principal.src = src;
        miniaturas.forEach((m) => m.classList.remove('is-active'));
        mini.classList.add('is-active');
      });
    });
  });
}

function mtInitVariantes() {
  document.querySelectorAll('[data-mt-producto-form]').forEach((form) => {
    const dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    let variantes = [];
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const pills = form.querySelectorAll('[data-mt-pill]');
    const idInput = form.querySelector('[data-mt-variant-id]');
    const precioActual = form.querySelector('[data-mt-precio-actual]');
    const precioAnterior = form.querySelector('[data-mt-precio-anterior]');
    const boton = form.querySelector('[data-mt-add-cart]');

    function opcionesSeleccionadas() {
      const seleccion = {};
      form.querySelectorAll('[data-mt-opcion]').forEach((grupo) => {
        const nombre = grupo.getAttribute('data-mt-opcion');
        const activo = grupo.querySelector('.is-selected');
        if (activo) seleccion[nombre] = activo.getAttribute('data-valor');
      });
      return seleccion;
    }

    function encontrarVariante() {
      const seleccion = opcionesSeleccionadas();
      return variantes.find((v) =>
        v.options.every((valor, i) => valor === seleccion[v.optionNames[i]])
      );
    }

    function formatoDinero(centavos) {
      return '$' + (centavos / 100).toFixed(2);
    }

    function actualizar() {
      const variante = encontrarVariante();
      if (!variante) {
        if (boton) {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-no-disponible') || 'No disponible';
        }
        return;
      }
      if (idInput) idInput.value = variante.id;
      if (precioActual) precioActual.textContent = formatoDinero(variante.price);
      if (precioAnterior) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAnterior.textContent = formatoDinero(variante.compare_at_price);
          precioAnterior.style.display = '';
        } else {
          precioAnterior.style.display = 'none';
        }
      }
      if (boton) {
        if (variante.available) {
          boton.disabled = false;
          boton.textContent = boton.getAttribute('data-texto-comprar') || 'Añadir al carrito';
        } else {
          boton.disabled = true;
          boton.textContent = boton.getAttribute('data-texto-agotado') || 'Agotado';
        }
      }

      document.dispatchEvent(new CustomEvent('mt:variante-cambiada', { detail: variante }));
    }

    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.classList.contains('is-unavailable')) return;
        const grupo = pill.closest('[data-mt-opcion]');
        grupo.querySelectorAll('[data-mt-pill]').forEach((p) => p.classList.remove('is-selected'));
        pill.classList.add('is-selected');
        actualizar();
      });
    });

    actualizar();
  });
}

function mtFormatoDinero(centavos) {
  return '$' + (centavos / 100).toFixed(2);
}

function mtInitCantidad() {
  document.querySelectorAll('[data-mt-cantidad]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const menos = wrap.querySelector('[data-mt-cantidad-menos]');
    const mas = wrap.querySelector('[data-mt-cantidad-mas]');
    if (!input) return;
    menos?.addEventListener('click', () => {
      const valor = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = valor;
    });
    mas?.addEventListener('click', () => {
      const valor = (parseInt(input.value, 10) || 1) + 1;
      input.value = valor;
    });
  });
}

function mtInitSincroniaGlobal() {
  const elementosActual = document.querySelectorAll('[data-mt-precio-global-actual]');
  const elementosAnterior = document.querySelectorAll('[data-mt-precio-global-anterior]');
  const elementosAhorro = document.querySelectorAll('[data-mt-ahorro-global]');
  const idsGlobales = document.querySelectorAll('[data-mt-variant-id-global]');
  const botonesGlobales = document.querySelectorAll('[data-mt-add-cart-global]');
  if (!elementosActual.length && !idsGlobales.length && !botonesGlobales.length) return;

  document.addEventListener('mt:variante-cambiada', (evento) => {
    const variante = evento.detail;
    if (!variante) return;

    elementosActual.forEach((el) => { el.textContent = mtFormatoDinero(variante.price); });

    const tieneDescuento = variante.compare_at_price && variante.compare_at_price > variante.price;
    elementosAnterior.forEach((el) => {
      el.style.display = tieneDescuento ? '' : 'none';
      if (tieneDescuento) el.textContent = mtFormatoDinero(variante.compare_at_price);
    });
    elementosAhorro.forEach((el) => {
      if (tieneDescuento) {
        const ahorro = variante.compare_at_price - variante.price;
        el.style.display = '';
        el.textContent = el.getAttribute('data-plantilla').replace('__AHORRO__', mtFormatoDinero(ahorro));
      } else {
        el.style.display = 'none';
      }
    });
    idsGlobales.forEach((input) => { input.value = variante.id; });
    botonesGlobales.forEach((boton) => {
      boton.disabled = !variante.available;
      boton.textContent = variante.available
        ? boton.getAttribute('data-texto-comprar') || 'Añadir al carrito'
        : boton.getAttribute('data-texto-agotado') || 'Agotado';
    });
  });
}

function mtInitBarraFija() {
  const barra = document.querySelector('[data-mt-barra-fija]');
  const trigger = document.querySelector('[data-mt-producto-form]');
  if (!barra || !trigger) return;
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        barra.classList.toggle('is-visible', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  observer.observe(trigger);
}

document.addEventListener('DOMContentLoaded', () => {
  mtInitReveals();
  mtInitProductoGaleria();
  mtInitVariantes();
  mtInitCantidad();
  mtInitSincroniaGlobal();
  mtInitBarraFija();
});
